

























import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex";
import Spinner from "@/components/Spinner.vue";
import { LOAD_STATE } from "@/status";

@Component({
  components: {
    Spinner
  }
})
export default class ProjectList extends Vue {
  public mounted() {
    this.$store.dispatch("fetchProjects");
  }

  get projects() {
    return this.$store.state.projects;
  }

  get projectCount() {
    return this.projects.length;
  }

  get noData() {
    return (
      this.$store.state.status.projects === LOAD_STATE.EMPTY ||
      this.$store.state.status.projects === LOAD_STATE.LOADING
    );
  }

  get isLoading() {
    return this.$store.state.status.projects === LOAD_STATE.LOADING;
  }

  get modulusSpice() {
    const r = [];
    for (let i = 0; i < this.projectCount; i += 3) {
      r.push(this.projects.slice(i, i + 3));
    }
    return r;
  }
}
